<a class="notification-link" (click)="downloadFile()">{{
  'QualityManagement::ClickHereToDownloadEvaluationResultsReport' | abpLocalization
}}</a>
